<div>
  <div
    class="col-sm-3 col-md-3 col-lg-3 custom-gray-border"
    *ngIf="!showFlyingWindow && (multiCountryDraft || purePriceWindow)"
    (click)="openFlyingOutWindow()"
  ></div>
</div>
<div
  class="col-sm-3 col-md-3 col-lg-3 custom-multicountry-box"
  [hidden]="!showFlyingWindow"
>
  <div
    class="col-sm-3 col-md-3 col-lg-3 custom-multicountry-in"
    [ngClass]="{
      'height-170': !isTCSPAEditMode && surveyDetails && purePriceWindow
    }"
    (click)="openFlyingOutWindow(true)"
  ></div>
  <ps-ui-multi-country-draft
    *ngIf="multiCountryDraftData?.countryData?.length || multiCountryDraft"
    [surveyDetails]="surveyDetails"
    (selectionChange)="openFlyingOutWindow(true)"
    [countries]="countries"
    [mcSurveyPayload]="mcSurveyPayload"
    [mcSurveyAddType]="mcSurveyAddType"
    [isMultiCountryTemplate]="isMultiCountryTemplate"
    (mcSurveyAdded)="informOnMcSurveyAdded()"
  ></ps-ui-multi-country-draft>
  <ps-ui-pure-price-window
    *ngIf="!isTCSPAEditMode && surveyDetails && purePriceWindow"
    (purePriceApplied)="applyPurePrice($event)"
    (purePriceFieldTimeApplied)="applyPurePriceV2($event)"
    [(appliedQuotaName)]="appliedQuotaName"
    [purePriceData]="purePriceData"
    [surveyDetails]="surveyDetails"
  >
  </ps-ui-pure-price-window>
</div>
